<div class="page-header-container">
    <div class="page-title">
        {{'requests.clientData.newRequest.Title' | translate}}
    </div>
</div>

<div class="wizard-container">
    <button class="btn link-btn btn-back-txt" (click)="redirectFieldSelectionHandler()">
        <i class="app-icon icon icon-arrow-left icon-xl me-2"></i>
        <span>{{'requests.clientData.newRequest.Back' | translate}}</span>
    </button>

    <div class="row">
        <span class="col-12 d-flex justify-content-center title">{{'requests.clientData.newRequest.legal.Title' | translate}}</span>
    </div>

    <form #form="ngForm" class="l-form">
        <ng-container *ngFor="let legalRepresentative of clientDataRequestSaveModel.legalRepresentatives; let i = index">
            <div class="row justify-content-center">
                <div class="col-xxl-3 mb-2">
                    <label class="text-field-label">{{'requests.clientData.newRequest.legal.FirstName' | translate}} 
                        <span class="text-primary fw-bold">*</span>
                    </label>
                    <input kendoTextBox 
                        class="text-input" 
                        [(ngModel)]="legalRepresentative.firstName" 
                        required 
                        name="firstName-{{i}}"
                        #firstName="ngModel"/>
                    <div class="error-info" *ngIf="firstName.invalid  && (firstName.dirty || form.submitted)">
                        <div  *ngIf="firstName.errors?.['required']">
                            {{'common.validation.required' | translate}}
                        </div>
                    </div>  
                </div>
                <div class="col-xxl-3 mb-2">
                    <label class="text-field-label">{{'requests.clientData.newRequest.legal.LastName' | translate}} 
                        <span class="text-primary fw-bold">*</span>
                    </label>
                    <input kendoTextBox 
                        class="text-input" 
                        [(ngModel)]="legalRepresentative.lastName" 
                        required 
                        name="lastName-{{i}}"
                        #lastName="ngModel"/>
                    <div class="error-info" *ngIf="lastName.invalid  && (lastName.dirty || form.submitted)">
                        <div  *ngIf="lastName.errors?.['required']">
                            {{'common.validation.required' | translate}}
                        </div>
                    </div>  
                </div>
                <div class="col-xxl-3 mb-2">
                    <label class="text-field-label">{{'requests.clientData.newRequest.contactInformation.Phone' | translate}} 
                        <span class="text-primary fw-bold">*</span>
                    </label>
                    <input kendoTextBox 
                        class="text-input" 
                        type="number" 
                        [(ngModel)]="legalRepresentative.phone" 
                        required 
                        name="phone-{{i}}"
                        #phone="ngModel"/>
                    <div class="error-info" *ngIf="phone.invalid  && (phone.dirty || form.submitted)">
                        <div  *ngIf="phone.errors?.['required']">
                            {{'common.validation.required' | translate}}
                        </div>
                    </div>  
                </div>
                <div class="col-xxl-1 mt-4 text-center">
                    <button type="button" class="btn delete-btn delete-btn-circle" 
                        (click)="removeLegalRepresenativeHandler(i)">
                        <i class="app-icon icon icon-delete icon-lg"></i>
                    </button>
                </div>
            </div>
            <div class="divider-line option-row"></div>
        </ng-container>
 

    <div class="d-flex justify-content-center">
        <button type="button" class="btn add-btn" (click)="addPersonHandler()">
            <span>{{'requests.clientData.newRequest.legal.Add' | translate}}</span>
            <i class="app-icon icon icon-add ms-2"></i>
        </button>
    </div>
    
        <div class="divider-line option-row"></div>

        <div class="d-flex justify-content-center">
            <client-data-request-uploader 
                [clientDataRequest]="clientDataRequestSaveModel" 
                [deleteFileHandler]="_filesHandler.deleteFileHandler"
                [uploadFilesHandler]="_filesHandler.uploadFilesHandler">
            </client-data-request-uploader>
        </div>

        <div class="d-flex justify-content-center mt-5">
            <button type="submit" class="btn primary-btn px-5" 
                (click)="sendRequestCofirmationHandler()">
                <span class="send-text">
                    {{ 'requests.clientData.newRequest.Next' | translate}}
                </span>
            </button>
        </div>
    </form>
</div>
